<template>
	<sf-modal-layout size="xl" :title="getMessage_('QWCC001528')" :show="show" :closeModal="close">
		<div class="mb-3">
			<sf-button v-if="isButton_(scrId, 'CC') && (isMmcUser || isMmcAdmin)" line icon="file" :onClick="saveAction">
				<!-- 저장 -->
				{{ getMessage_('QWCC001131') }}
			</sf-button>
		</div>
		<div class="sf-table">
			<table class="qms-table">
				<tbody>
					<tr>
						<th>{{ getMessage_('QWCC001317') }}</th>
						<!-- 관리번호 -->
						<th>{{ getMessage_('QWCC001314') }}</th>
						<!-- 장비명 -->
						<th>{{ getMessage_('QWCC001251') }}</th>
						<!-- 신청자 -->
						<th>{{ getMessage_('QWCC001530') }}</th>
						<!-- 신청 일시 -->
						<th>{{ getMessage_('QWCC001531') }}</th>
						<!-- 신청 부서 -->
						<th>{{ getMessage_('QWCC001532') }}</th>
						<!-- 가동 상태 -->
					</tr>

					<tr>
						<td>{{ saveData.mesEqipNo }}</td>
						<td>{{ saveData.mesEqipNm }}</td>
						<td>{{ user.userName }}</td>
						<td><el-date-picker format="yyyy-MM-dd" value-format="yyyyMMdd" v-model="saveData.apcnDd" readonly /></td>
						<td>{{ saveData.apcnDeptNm }}</td>
						<td>
							<sf-select-group
								labelPosition="left"
								:inputValue="saveData.runStCd"
								:options="runStCdList"
								:onChange="
									val => {
										saveData.runStCd = val;
									}
								"
								:placeholder="getMessage_('QWCC001532')"
							/>
						</td>
					</tr>
					<tr>
						<th colspan="6">{{ getMessage_('QWCC000053') }}</th>
					</tr>
					<tr>
						<td colspan="6">
							<el-input type="textarea" :rows="4" maxlength="65" :show-word-limit="true" v-model="saveData.rmk" />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '../../store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			saveData: {
				mesEqipNo: '',
				mesEqipNm: '',
				apcnDd: this.$moment().format('YYYYMMDD'),
				apcnDeptCd: '',
				apcnDeptNm: '',
				runStCd: '',
				rmk: '',
				sndStCd:''
			}
		};
	},
	async created() {
		const { deptCd, deptNm } = await this.getUsrFullInfo_();
		this.saveData.apcnDeptCd = deptCd;
		this.saveData.apcnDeptNm = deptNm;
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		open({ mesEqipNo, mesEqipNm, prbmStCd, runStCd,sndStCd }) {
			this.show = true;
			this.saveData = { ...this.saveData, mesEqipNo, mesEqipNm, runStCd: prbmStCd || runStCd ,sndStCd };
		},
		close() {
			this.initPopup();
			this.$emit('Refresh');
			this.show = false;
		},
		initPopup() {
			this.saveData.mesEqipNo = '';
			this.saveData.mesEqipNm = '';
			this.saveData.runStCd = '';
			this.saveData.apcnDeptCd = this.user.deptCd;
			this.saveData.apcnDd = this.$moment().format('YYYYMMDD');
			this.saveData.rmk = '';
			this.saveData.sndStCd = '';
		},
		saveAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('QWCC001310'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		async save() {
			this.$sf_toggleLoading(true);
			try {
				const header = await this.savePrbmMesInfo_(this.saveData);
				if (header?.code == 0) {
					this.$sf_showMessage({
						icon: 'ok',
						message: this.getMessage_(header.messageCd),
						closeFn: this.close
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
